import React, { useEffect, useState } from "react";
import * as S from "../css/Calendar.styles";
import MenuComponent from "../component/MenuComponent";
import CalendarComponent from "../component/calendar/CalendarComponent";
import { useRecoilValue } from "recoil";
import { loginState } from "../stores/loginState";
import { formatNumberCommas } from "../utils/formatNumberCommas";
import useGetCalenderData from "../api/calendar/useGetCalenderData";
import { calendarDataState } from "../stores/calendar/calendarDataState";
import dayjs from "dayjs";
import { todayState } from "../stores/dashboard/todayState";

function Calendar(props) {
  // NOTE 상태 변수 선언
  const login = useRecoilValue(loginState); // 로그인 전역변수
  const [date, setDate] = useState(new Date()); // 일자
  const [viewMonth, setViewMonth] = useState(date.getMonth()); // 월 계산 변수
  const calendarData = useRecoilValue(calendarDataState); // 월별 데이터 전역변수
  const todayData = useRecoilValue(todayState);
  let totalSum = 0;
  const days = [  // 일자 산안
    "일요일",
    "월요일",
    "화요일",
    "수요일",
    "목요일",
    "금요일",
    "토요일",
  ];
  const workType = login.company === "LOGEN" ? ["배송입고", "집하출고"] :
    login.company === "LOGEN" ? ["도　　착", "발　　송"] : ["간선상차", "간선하차"]; // 용어 구분

  // TODO 월별 데이터 호출 API
  const { mutate: getCalenderData } = useGetCalenderData(date.toISOString().split("T")[0]);

  // 월변경 함수
  const changeMonth = (months) => {
    setDate((prevDate) => {
      const newDate = new Date(prevDate);
      newDate.setMonth(newDate.getMonth() + months);
      setViewMonth(newDate.getMonth()); // 보이는 월 업데이트
      return newDate;
    });
  };

  // NOTE 요일별 운송장 총합 계산하는 함수
  const calculateTotalsByDay = () => {
    // 기본 0으로 설정
    const totals = {
      "일요일": { dvIn: 0, dvOut: 0 },
      "월요일": { dvIn: 0, dvOut: 0 },
      "화요일": { dvIn: 0, dvOut: 0 },
      "수요일": { dvIn: 0, dvOut: 0 },
      "목요일": { dvIn: 0, dvOut: 0 },
      "금요일": { dvIn: 0, dvOut: 0 },
      "토요일": { dvIn: 0, dvOut: 0 },
    };
  
    // 데이터 받아올 시 요일별로 합산
    if (calendarData) {
      calendarData.forEach((monthData) => {
        Object.keys(monthData.dayskey).forEach((dateKey) => {
          const entry = monthData.dayskey[dateKey];
          const entryDate = new Date(dateKey);
          if (entryDate.getMonth() + 1 === date.getMonth() + 1 && entryDate.getFullYear() === date.getFullYear()) {
            const day = days[entryDate.getDay()];
            totals[day].dvIn += parseInt(entry.deliveryInCount, 10);
            totals[day].dvOut += parseInt(entry.deliveryOutCount, 10);
            totalSum += parseInt(entry.deliveryInCount, 10) + parseInt(entry.deliveryOutCount, 10);
          }
        });
      });
    }

    // 오늘 날짜 및 요일 확인 (dayjs 사용)
    const today = dayjs();
    const todayDay = days[today.day()]; // 오늘이 무슨 요일인지 확인

    // 오늘 데이터가 존재하면 해당 요일에 추가
    if (todayData && viewMonth === today.month()) {
      totals[todayDay].dvIn += parseInt(todayData.deliveryInTotal, 10);
      totals[todayDay].dvOut += parseInt(todayData.deliveryOutTotal, 10);
      totalSum += todayData.total;
    }
    return totals;
  };

  // 해당 변수에 요일별 운송장 총합 저장
  const totalsByDay = calculateTotalsByDay();

  // NOTE 월변경 함수
  const handleDateChange = (event) => {
    const newDate = new Date(event.target.value);
    setDate(newDate);
    setViewMonth(newDate.getMonth()); // 보이는 월 업데이트
  };

  // NOTE 현재 월로 돌아오는 함수
  const handleTodayClick = () => {
    const today = new Date();
    setDate(today);
    setViewMonth(today.getMonth()); // 보이는 월 업데이트
  };

  // NOTE 페이지 로드, 날짜정보 변경 시 자동으로 데이터 호출
  useEffect(() => {
    getCalenderData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [date]);

  return (
    <S.DashboardContainer>
      <MenuComponent theme={props.theme} />
      <S.ContentContainer>
        <S.CalendarContainer>
          <S.HeaderContainer>
            <S.ControllContainer>
              <h4>월별실적조회</h4>
              <S.SelectContainer>
                <h2 style={{ fontWeight: 800 }}>
                  {date.toLocaleString("ko-KR", {
                    year: "numeric",
                    month: "long",
                  })}
                </h2>
                <S.Input
                  type="month"
                  value={date.toISOString().slice(0, 7)} // 날짜를 YYYY-MM-DD 형식으로 변환
                  onChange={handleDateChange} // 날짜 변경 시 핸들러 호출
                />
                <S.SelectBar>
                  <img
                    src={require("../assets/icons/arrow-right (1).png")}
                    alt=""
                    title="이전 달 이동"
                    onClick={() => changeMonth(-1)}
                  />
                  <img src={require("../assets/icons/rhomb.png")} 
                    alt="오늘로 이동"
                    title="오늘로 이동"
                    onClick={handleTodayClick}/>
                  <img
                    src={require("../assets/icons/arrow-right.png")}
                    alt=""
                    title="다음 달 이동"
                    onClick={() => changeMonth(1)}
                  />
                </S.SelectBar>
              </S.SelectContainer>
            </S.ControllContainer>
            <S.HeaderViewContainer>
              <h3>총합 : {formatNumberCommas(totalSum) || 0} 건</h3>
            </S.HeaderViewContainer>
          </S.HeaderContainer>
          <S.WeekdayContainer>
            <span>일</span>
            <span>월</span>
            <span>화</span>
            <span>수</span>
            <span>목</span>
            <span>금</span>
            <span>토</span>
          </S.WeekdayContainer>
          <S.CalendarDiv>
            <CalendarComponent
              date={date}
              setDate={setDate}
              viewMonth={viewMonth}
              setViewMonth={setViewMonth}
            />
          </S.CalendarDiv>
          <S.FooterContainer>
            {days.map((day) => (
              <div key={day} style={day === "토요일" ? { background: props.theme.colorwhite1 } :
              day === "일요일" ? { background: props.theme.colorwhite5 } : undefined}>
                <h5>{day} 총 건수</h5>
                <span>
                  <p>{workType[0]} : </p>
                  <p>{formatNumberCommas(totalsByDay[day].dvIn)} 건</p>
                </span>
                <span>
                  <p>{workType[1]} : </p>
                  <p>{formatNumberCommas(totalsByDay[day].dvOut)} 건</p>
                </span>
                <span>
                  <p>합　　계 : </p>
                  <p>{formatNumberCommas(totalsByDay[day].dvIn + totalsByDay[day].dvOut)} 건</p>
                </span>
              </div>
            ))}
          </S.FooterContainer>
        </S.CalendarContainer>
      </S.ContentContainer>
    </S.DashboardContainer>
  );
}

export default Calendar;
